export default __webpack_public_path__ + "static/media/icon-round-easily-develop@2x.feed9337.png";